import { App as AntApp, ConfigProvider } from 'antd';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './context/AuthContext';
import Admins from './pages/Admins';
import Home from './pages/Home';
import Login from './pages/Login';
import Tenants from './pages/Tenants';

function App() {
  return (
    <ConfigProvider>
      <AntApp>
        <BrowserRouter>
          <AuthProvider>
            <Routes>
              {/* Public routes */}
              <Route path="/login" element={<Login />} />
              
              {/* Protected routes */}
              <Route path="/" element={<ProtectedRoute><Home /></ProtectedRoute>}>
                <Route path="users" element={<ProtectedRoute><Admins /></ProtectedRoute>} />
                <Route path="tenants" element={<ProtectedRoute><Tenants /></ProtectedRoute>} />
                <Route path="*" element={<Navigate to="users" replace />} />
              </Route>
            </Routes>
          </AuthProvider>
        </BrowserRouter>
      </AntApp>
    </ConfigProvider>
  );
}

export default App;